export const MOCK_ALLOCATION_PRODUCTS = [
  {
    id: "prod-101",
    name: "MCB 32A C-Curve 3-Pole",
    manufacturer: "Schneider Electric",
    partNumber: "LS-MCB-32C3",
    uom: "Nos",
    availableQty: 150,
  },
  {
    id: "prod-102",
    name: "Submersible Pump Type A",
    manufacturer: "Kirloskar Brothers",
    partNumber: "WP-SUB-A01",
    uom: "Nos",
    availableQty: 95,
  },
  {
    id: "prod-103",
    name: "Gate Valve DN100 PN16",
    manufacturer: "L&T Valves",
    partNumber: "FL-GVAL-100",
    uom: "Nos",
    availableQty: 10,
  },
  {
    id: "prod-104",
    name: "LED Panel Light 15W 6500K",
    manufacturer: "Philips Lighting",
    partNumber: "LT-PAN-15W",
    uom: "Nos",
    availableQty: 220,
  },
];

export const MOCK_BATCHES = [
  // MCB 32A C-Curve 3-Pole
  {
    batchNumber: "B-MCB-001",
    productId: "prod-101",
    warehouse: "Warehouse Bangalore",
    availableQty: 60,
    receiptDate: "2025-01-10",
    warrantyEndDate: "2026-06-30",
  },
  {
    batchNumber: "B-MCB-002",
    productId: "prod-101",
    warehouse: "Peelamedu Depot",
    availableQty: 50,
    receiptDate: "2025-04-15",
    warrantyEndDate: "2026-08-31",
  },
  {
    batchNumber: "B-MCB-003",
    productId: "prod-101",
    warehouse: "Warehouse Mysore",
    availableQty: 40,
    receiptDate: "2025-02-05",
    warrantyEndDate: null, // Null warranty sorts last in FEFO
  },

  // Submersible Pump Type A
  {
    batchNumber: "B-PMP-001",
    productId: "prod-102",
    warehouse: "Warehouse Bangalore",
    availableQty: 40,
    receiptDate: "2024-11-20",
    warrantyEndDate: "2025-11-30", // Expired warranty
  },
  {
    batchNumber: "B-PMP-002",
    productId: "prod-102",
    warehouse: "Warehouse Mysore",
    availableQty: 30,
    receiptDate: "2025-03-01",
    warrantyEndDate: "2026-03-31",
  },
  {
    batchNumber: "B-PMP-003",
    productId: "prod-102",
    warehouse: "Warehouse Chennai",
    availableQty: 25,
    receiptDate: "2025-06-10",
    warrantyEndDate: null, // Null warranty sorts last in FEFO
  },

  // Gate Valve DN100 PN16
  {
    batchNumber: "B-VAL-001",
    productId: "prod-103",
    warehouse: "Coimbatore Central Warehouse",
    availableQty: 10,
    receiptDate: "2025-05-18",
    warrantyEndDate: "2027-05-18",
  },

  // LED Panel Light 15W 6500K
  {
    batchNumber: "B-LED-001",
    productId: "prod-104",
    warehouse: "Peelamedu Depot",
    availableQty: 100,
    receiptDate: "2025-02-14",
    warrantyEndDate: "2026-12-31",
  },
  {
    batchNumber: "B-LED-002",
    productId: "prod-104",
    warehouse: "Warehouse Chennai",
    availableQty: 120,
    receiptDate: "2025-01-20", // Oldest receipt
    warrantyEndDate: "2026-10-31", // Earliest expiry
  },
];
